{
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.primary": [
    {
      "type": 0,
      "value": "Try Rovo now"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.secondary": [
    {
      "type": 0,
      "value": "Try Rovo now"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.subtitle": [
    {
      "type": 0,
      "value": "Jump into Confluence to discover what's possible."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.title": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature1.description": [
    {
      "type": 0,
      "value": "Prompt Rovo to start creating for you. Use anything across Confluence as input."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature1.link": [
    {
      "type": 0,
      "value": "Create with Rovo"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature1.title": [
    {
      "type": 0,
      "value": "Create any content with Rovo"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature2.description": [
    {
      "type": 0,
      "value": "Utilize Rovo in any doc or page by highlighting any text. Edit your writing or start drafting."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature2.link": [
    {
      "type": 0,
      "value": "Edit with Rovo"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature2.title": [
    {
      "type": 0,
      "value": "Edit with Rovo in docs and pages"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature3.description": [
    {
      "type": 0,
      "value": "Save time by using summaries and audio briefings to get the context you need."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature3.link": [
    {
      "type": 0,
      "value": "Try audio briefings"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature3.title": [
    {
      "type": 0,
      "value": "Get information faster"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.features.title": [
    {
      "type": 0,
      "value": "Use Rovo in a number of ways:"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.hero.alt": [
    {
      "type": 0,
      "value": "Atlassian Intelligence"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.rovo": [
    {
      "type": 0,
      "value": "Rovo"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.subtitle": [
    {
      "type": 0,
      "value": "Looks like you used "
    },
    {
      "type": 1,
      "value": "featureName"
    },
    {
      "type": 0,
      "value": " — here are more ways to use Rovo in Confluence."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.subtitle.video.variant": [
    {
      "type": 0,
      "value": "Looks like you used "
    },
    {
      "type": 1,
      "value": "featureName"
    },
    {
      "type": 0,
      "value": ". Here are a few more ideas for using Rovo."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.welcome": [
    {
      "type": 0,
      "value": "Welcome, "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.welcome-rovo": [
    {
      "type": 0,
      "value": "Let's look at "
    },
    {
      "type": 1,
      "value": "rovo"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.message-template.email.subject": [
    {
      "type": 0,
      "value": "Rovo is here for whatever you need"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.message-template.email.subject.aiAudioBriefings": [
    {
      "type": 0,
      "value": "Listen to what else Rovo can do"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.message-template.email.subject.aiChat": [
    {
      "type": 0,
      "value": "Use Rovo in a lot more ways than just chat"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.message-template.email.subject.aiDefinitions": [
    {
      "type": 0,
      "value": "Rovo can do more than just define"
    }
  ],
  "cc-flywheel-feature-discovery.rovo-awareness-survey.question": [
    {
      "type": 0,
      "value": "To what extent do you agree or disagree with the following statement?"
    }
  ],
  "cc-flywheel-feature-discovery.rovo-awareness-survey.statement": [
    {
      "type": 0,
      "value": "I'm aware of Atlassian Rovo and its functionalities."
    }
  ],
  "confluence-create-with-rovo-announcement-splash.modal.description": [
    {
      "type": 0,
      "value": "Rovo can help you create what you need. Describe what you want, and Rovo will start it for you."
    }
  ],
  "confluence-create-with-rovo-announcement-splash.modal.header": [
    {
      "type": 0,
      "value": "Introducing Create with Rovo"
    }
  ],
  "confluence-create-with-rovo-announcement-splash.modal.primary-button": [
    {
      "type": 0,
      "value": "Try Create with Rovo"
    }
  ],
  "post-office.confluence-create-with-rovo-side-nav-nudge.body": [
    {
      "type": 0,
      "value": "With a simple prompt, Rovo can draft a page or whiteboard."
    }
  ],
  "post-office.confluence-create-with-rovo-side-nav-nudge.call.to.action": [
    {
      "type": 0,
      "value": "Show me how"
    }
  ],
  "post-office.confluence-create-with-rovo-side-nav-nudge.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.confluence-create-with-rovo-side-nav-nudge.heading": [
    {
      "type": 0,
      "value": "You describe, Rovo creates"
    }
  ]
}